import { render, staticRenderFns } from "./shipment-timeline.vue?vue&type=template&id=caba3634&scoped=true&"
import script from "./shipment-timeline.vue?vue&type=script&lang=js&"
export * from "./shipment-timeline.vue?vue&type=script&lang=js&"
import style0 from "./shipment-timeline.vue?vue&type=style&index=0&id=caba3634&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caba3634",
  null
  
)

export default component.exports